import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./login/login.component";
import { MyProfileComponent } from "./my-profile/my-profile.component";
import { AccessCodeByTokenComponent } from "./access-code-by-token/access-code-by-token.component";
import { GetAccessCodeComponent } from "./get-access-code/get-access-code.component";
import { LogOutComponent } from "./log-out/log-out.component";

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'my-profile', component: MyProfileComponent },
    { path: 'accessCode', component:GetAccessCodeComponent},
    { path: 'access', component:AccessCodeByTokenComponent},
    { path: 'logOut', component: LogOutComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthRoutingModule { }
